/*eslint-disable */
import axios from 'axios';
import createSubscriptionProduct from '../create-product';
import productClearPopup from '../product-clear-popup';
import {
  bus
} from '@/main';
import {
mapGetters,
} from 'vuex';
export default {
  name: 'product-list',
  components: {
    'subscription-product' : createSubscriptionProduct,
    'product-clear-popup' : productClearPopup
  },
  props: [],
  data () {
    return {
      subscriptionPlanInfo:null,
      subscriptionPlanInfoResults:[],
      createSubscriptionProductState:false,
      paginationList:[],
      loadmoreindex:0,
      productClearPopupState:false
    }
  },
  computed: {
    ...mapGetters([
      'getSubscriptionProductListGetters'
    ]),
    getSubscriptionProductListInfo(){
      this.subscriptionPlanInfo = this.$store.getters.getSubscriptionProductListGetters;
      return
    },
    setInitialStateOfProduct(){
      if(this.subscriptionPlanInfo){
        this.subscriptionPlanInfoResults = this.subscriptionPlanInfo.data
        this.paginationList = this.subscriptionPlanInfo.links
      }
      return;
    }
  },
  mounted () {
    this.getSubscriptionProductListInfo
    this.setInitialStateOfProduct
    bus.$on('allProductClearStateBus', (data) => {
      this.productClearPopupState = data;
    });
    bus.$on('createSubscriptionProductStateBus', (data) => {
      this.createSubscriptionProductState = data;
    });
  },
  methods: {
    allProductsClearStatePopupOpen(){
      this.productClearPopupState = true
      document.body.classList.add('body_right_scroll_remove')
    },
    createSubscriptionProductPopupOpen(){
      this.createSubscriptionProductState = true
      document.body.classList.add('body_right_scroll_remove')
    },
    prodcutListLoadMoreMethod(index){
      this.loadmoreindex = this.loadmoreindex + 1
      axios.get(index.href).then(res => {
      }).catch(err => {
      })
    }
  },
  watch:{
    getSubscriptionProductListInfo(){
      return this.$store.getters.getSubscriptionProductListGetters
    },
    setInitialStateOfProduct(){
      if(this.subscriptionPlanInfo){
        this.subscriptionPlanInfoResults = this.subscriptionPlanInfo.data
        this.paginationList = this.subscriptionPlanInfo.links
      }
      return;
    }
  }
}